"use strict";
exports.__esModule = true;
exports.SvgRetry = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgRetry = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M12 20h0a8 8 0 007.027-4.175M20 12h0a8 8 0 00-8-8m0 0h0a8 8 0 00-7.027 4.175M4 12h0a8 8 0 008 8" }),
        react_1["default"].createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M4.973 8.175h0A8 8 0 0120 12M4 12v.001a8 8 0 0015.028 3.823" }),
        react_1["default"].createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M8.047 8.175H4.512V4.639m11.441 11.186h3.535v3.536" }),
        react_1["default"].createElement("path", { d: "M0 0h24v24H0z" })))); };
//# sourceMappingURL=Retry.js.map